module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_vm._m(0), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/perfil"
    }
  }, [_vm._v("Perfil")])], 1), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/permissoes"
    }
  }, [_vm._v("Permissões")])], 1) : _vm._e(), _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/alterar-senha"
    }
  }, [_vm._v("Alterar Senha")])], 1), _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "id": "users",
      "to": "/configuracoes/usuarios"
    }
  }, [_vm._v("Usuários")])], 1), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/contatos/campos-personalizados"
    }
  }, [_vm._v("Propriedades")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/templates"
    }
  }, [_vm._v("Templates")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/tags"
    }
  }, [_vm._v("Tags")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/atividades"
    }
  }, [_vm._v("Atividades")])], 1) : _vm._e(), _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/integracoes"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.title.index')))])], 1), (_vm.show_company_management_menus) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/motivo-de-perda"
    }
  }, [_vm._v("Motivo de Perda")])], 1) : _vm._e(), (_vm.current_user.isAdmin()) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/empresas"
    }
  }, [_vm._v("Empresas")])], 1) : _vm._e(), (_vm.current_company.voip_service) ? _c('li', {
    staticClass: "sidebar-menu-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/configuracoes/voip"
    }
  }, [_vm._v("VoIP")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "sidebar-header"
  }, [_c('h3', {
    staticClass: "sidebar-header-title"
  }, [_vm._v(" Configurações")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92141032!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/sidebar.vue
// module id = 1191
// module chunks = 1